import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Data, User } from '~/utils';
import ProjectPortfolioTable from '@/components/project-portfolio/project-portfolio-table/project-portfolio-table.vue';

@Component({
    components: {
        ProjectPortfolioTable,
    }
})
export default class ProjectPortfolioComponent extends Vue {
    private userPermissions = <any>[];
    private isAccessDeniedModalActive: boolean = false;
    private data: Data = Data.Instance;

    async created() {
        this.userPermissions = await User.getPerm();
        if (!this.hasPermission) {
            $('#accessDeniedModal').modal('show');
            this.isAccessDeniedModalActive = true;
        }
    }

    private get hasPermission(): boolean {
        return this.userPermissions.includes('CombinedBudgetEdit');
    }

    private onClickCancel(value) {
        this.isAccessDeniedModalActive = value;
    }
}
